import { apiClient } from './api';

interface PlayTokenResponse {
  token: string;
  url: string;
}

export const srsService = {
  /**
   * Get a short-lived play token for an SRS stream.
   * GET /api/srs/play-token/?stream=X
   */
  async getPlayToken(stream: string): Promise<PlayTokenResponse> {
    return apiClient.get<PlayTokenResponse>(`/api/srs/play-token/?stream=${stream}`);
  },
};
